import { Link, Typography } from "@mui/material";
import React from "react";

const Copyright: React.FC = () => {
  return (
    <Typography variant="body2" color="inherit" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.kyokko.co.jp/">
        旭光電機 (株)
      </Link>{" "}
      {new Date().getFullYear()}.
    </Typography>
  );
};

export default Copyright;
